import React, { useState } from 'react';
import { getTodayKST } from 'utils';

interface IProps {
  closeModal: () => void;
  // 부모가 dim/정렬 컨테이너를 제공하는 경우(데스크톱 나란히 배치) dim 레이어를 생략
  embedded?: boolean;
}

// 개인정보 처리방침 개정 내용 안내 팝업 (DDPS 제공 전문, 2026-06)
const PrivacyPolicyRevisionNotice: React.FC<IProps> = ({
  closeModal,
  embedded = false,
}: IProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDontShowAgain = () => {
    setDontShowAgain(!dontShowAgain);
  };

  const handleClose = () => {
    if (dontShowAgain) {
      // 당일(KST) 자정까지 노출 안 함
      localStorage.setItem(
        'hideLocalStitchPrivacyRevisionPopup',
        getTodayKST(),
      );
    }
    closeModal();
  };

  return (
    <div className={embedded ? 'popup-bare' : 'dimd-layer'}>
      <div className="announcement-popup">
        <div className="announcement-header">
          <h2>개인정보 처리방침 개정 내용 안내 (시행 2026. 07. 01)</h2>
          <button type="button" className="btn-close" onClick={handleClose}>
            <span className="img-close" />
          </button>
        </div>

        <div className="announcement-content">
          <div className="announcement-text">
            <p>안녕하세요, 디앤디프라퍼티솔루션 주식회사입니다.</p>
            <p>항상 저희 홈페이지를 이용해 주셔서 진심으로 감사드리며,</p>
            <p>개인정보처리방침이 아래와 같이 개정됨을 알려드립니다.</p>

            <p className="sub-title">■ 주요 변경 내용</p>
            <div className="table-scroll">
              <table className="revision-table">
                <thead>
                  <tr>
                    <th>기존 조항</th>
                    <th>변경 후 조항</th>
                    <th>주요 변경 내용</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2. 개인정보 수집 및 이용</td>
                    <td>제1조 개인정보의 처리 목적, 항목, 처리 및 보유 기간</td>
                    <td>
                      - 동의 기반 처리 항목과 법적 근거 등에 따른 비동의 처리
                      항목으로 분리·정리
                      <br />- 실제 수집 항목 등 내용 구분 기준 최신화
                    </td>
                  </tr>
                  <tr>
                    <td>2-3. 8세 이하 아동 등의 보호의무자의 권리 보호</td>
                    <td>삭제</td>
                    <td>
                      - 해당 정보(8세 이하 아동 등)를 수집하지 않으므로 조항
                      삭제
                    </td>
                  </tr>
                  <tr>
                    <td>3. 개인정보 제공</td>
                    <td>제3조 개인정보처리업무의 위탁</td>
                    <td>
                      - 제3자 제공 내역이 없으므로 관련 내용 삭제 및 위탁 구조
                      명확화
                    </td>
                  </tr>
                  <tr>
                    <td>4. 개인정보 파기</td>
                    <td>제2조 개인정보의 파기</td>
                    <td>- 개인정보 파기 절차 및 파기 방법을 보다 구체적으로 명시</td>
                  </tr>
                  <tr>
                    <td>(신설)</td>
                    <td>제4조 개인정보의 안정성 확보조치</td>
                    <td>
                      - 개인정보를 안전하게 보호하기 위한 기술적·관리적·물리적
                      조치 사항 신설
                    </td>
                  </tr>
                  <tr>
                    <td>
                      6. 개인정보 자동수집 장치의 설치·운영 및 거부에 관한 사항
                    </td>
                    <td>
                      제5조 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한
                      사항
                    </td>
                    <td>
                      - 쿠키(Cookie) 등 자동수집 장치의 허용 및 차단(거부) 방법을
                      구체화
                    </td>
                  </tr>
                  <tr>
                    <td>7. 가명정보 처리에 관한 사항</td>
                    <td>삭제</td>
                    <td>- 가명정보를 처리하지 않으므로 관련 조항 삭제</td>
                  </tr>
                  <tr>
                    <td>8. 기타사항</td>
                    <td>제7조 개인정보보호 책임자 및 권익 침해 구제 방법</td>
                    <td>
                      - 개인정보보호 책임자 및 담당 부서 변경사항 반영
                      <br />- 개인정보 침해 신고 기관 정보 최신화
                    </td>
                  </tr>
                  <tr>
                    <td>5. 개인정보처리방침의 변경</td>
                    <td>제8조 개인정보 처리방침의 변경에 관한 사항</td>
                    <td>
                      - 개정 이력 관리 및 변경 고지에 관한 사항으로 조항 순서 및
                      명칭 변경
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="sub-title">■ 적용 시기</p>
            <p>
              개인정보처리방침 개정은 <strong>2026년 07월 01일</strong>부터
              효력이 발생합니다.
            </p>
            <p>
              디앤디프라퍼티솔루션 주식회사 개인정보 처리방침 문의는{' '}
              secure@dndproperty.com 으로 문의주시기 바라며,
            </p>
            <p>앞으로도 고객님께 더 큰 만족을 드릴 수 있도록 최선을 다하겠습니다.</p>
            <p>감사합니다.</p>

            <p className="sub-title">■ 기타</p>
            <p>전문은 홈페이지에서 확인 가능합니다.</p>
            <p>
              <a
                href="https://dndproperty.com/pages/localstitch"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://dndproperty.com/pages/localstitch
              </a>
            </p>
          </div>

          <div className="dont-show-again">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="dontShowPrivacyRevision"
                checked={dontShowAgain}
                onChange={handleDontShowAgain}
              />
              <label htmlFor="dontShowPrivacyRevision">오늘 하루 그만보기</label>
            </div>
            <button type="button" onClick={handleClose}>
              닫기
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .dimd-layer {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        /* 부모(데스크톱 나란히 배치 컨테이너)가 dim/정렬을 담당하는 경우 */
        .popup-bare {
          display: flex;
        }

        /* 나란히 배치 시 두 팝업이 화면을 나눠 갖도록 폭 축소 */
        .popup-bare .announcement-popup {
          max-width: 520px;
          max-height: 86vh;
        }

        .announcement-popup {
          position: relative;
          background-color: white;
          width: 100%;
          max-width: 650px;
          max-height: 90vh;
          overflow-y: auto;
          padding: 40px 30px;
          border-radius: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .announcement-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 25px;
        }

        .btn-close {
          position: static;
          background: none;
          border: none;
          cursor: pointer;
          line-height: 1;
          width: 30px;
          height: 30px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .btn-close .img-close {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('/images/x-button.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        .announcement-content {
          text-align: left;
        }

        h2 {
          font-size: 22px;
          font-weight: 700;
          text-align: left;
          letter-spacing: -0.5px;
          margin: 0;
          line-height: 1.4;
        }

        .announcement-text {
          line-height: 1.5;
          font-size: 15px;
          color: #000;
          letter-spacing: -0.5px;
          margin-bottom: 30px;
        }

        .announcement-text p {
          margin-bottom: 5px;
        }

        .announcement-text a {
          color: #1a73e8;
          text-decoration: underline;
          word-break: break-all;
        }

        .sub-title {
          font-weight: 700;
          margin-top: 18px;
          margin-bottom: 8px;
        }

        .table-scroll {
          width: 100%;
          overflow-x: auto;
          margin: 6px 0 4px;
        }

        .revision-table {
          width: 100%;
          min-width: 460px;
          border-collapse: collapse;
          font-size: 13px;
          line-height: 1.45;
        }

        .revision-table th,
        .revision-table td {
          border: 1px solid #ddd;
          padding: 8px 10px;
          text-align: left;
          vertical-align: top;
        }

        .revision-table th {
          background-color: #f5f5f5;
          font-weight: 700;
          white-space: nowrap;
        }

        .spacing {
          height: 10px;
        }

        .dont-show-again {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #000;
          padding-top: 15px;
          padding-left: 0;
        }

        .checkbox-wrapper {
          display: flex;
          align-items: center;
          padding-left: 0;
          margin-left: 0;
        }

        .dont-show-again input[type='checkbox'] {
          appearance: none;
          -webkit-appearance: none;
          margin-left: 0;
          position: relative;
          cursor: pointer;
          vertical-align: middle;
        }

        .dont-show-again input[type='checkbox']:checked {
          background-color: #fff;
          border-color: #ccc;
        }

        .dont-show-again input[type='checkbox']:checked:after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 10px;
          border: solid #333;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .dont-show-again label {
          font-size: 15px;
          height: 18px;
          line-height: 18px;
          cursor: pointer;
        }

        .dont-show-again button {
          padding-bottom: 1px;
          border-bottom: 1px solid #000;
          cursor: pointer;
          font-size: 15px;
        }

        @media (max-width: 768px) {
          .announcement-popup {
            padding: 30px 20px;
            max-height: 80vh;
          }

          h2 {
            font-size: 16px;
          }

          .announcement-text {
            font-size: 13px;
          }

          .revision-table {
            font-size: 12px;
            min-width: 420px;
          }

          .revision-table th,
          .revision-table td {
            padding: 6px 7px;
          }

          .btn-close .img-close {
            width: 20px;
            height: 20px;
          }

          .dont-show-again,
          .dont-show-again label,
          .dont-show-again button {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicyRevisionNotice;
